// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab5476ca","455":"1fc9dd10","977":"90b9d982"}[chunkId] + ".chunk.js";
};